import { Chip } from "@material-ui/core";
import type { EpocusReferralStatus } from "../../../../global-providers/rxdb-provider/collections/epocus-referral";
import { rem } from "../../_lib/epocus-palette";

const STATUS_CONFIG: Record<
  EpocusReferralStatus,
  { label: string; bg: string; color: string }
> = {
  sent: { label: "Sent", bg: "#fef3c7", color: "#d97706" },
  acknowledged: { label: "Acknowledged", bg: "#dbeafe", color: "#2563eb" },
  outcomeRecorded: {
    label: "Outcome Recorded",
    bg: "#dcfce7",
    color: "#16a34a",
  },
};

export const ReferralStatusChip: FC<{ status: EpocusReferralStatus }> = ({
  status,
}) => {
  const { label, bg, color } = STATUS_CONFIG[status];
  return (
    <Chip
      label={label}
      size="small"
      style={{
        backgroundColor: bg,
        color,
        fontWeight: 700,
        fontSize: rem(12),
      }}
    />
  );
};
